import React from 'react';
import PropTypes from 'prop-types';
import './Headline.scss';
import Markdown from '../Markdown/Markdown';

const Headline = ({ title, description }) => (
    <div className="headline">
        <h1 className="headline__title" data-cy="headline">
            {title}
        </h1>
        {description && <Markdown content={description} style="headline__description" />}
    </div>
);

Headline.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
};

export default Headline;
